'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jsonToDate;
var _formatTime = require('./format-time');
var _formatTime2 = _interopRequireDefault(_formatTime);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function jsonToDate(json) {
  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var day = json.day.toString();
  var month = json.month.toString();
  var year = json.year.toString();
  if (day.length === 1) {
    day = '0' + day;
  }
  if (month.length === 1) {
    month = '0' + month;
  }
  var date = day + '/' + month + '/' + year;
  if (withTime) {
    date += ' ' + (0, _formatTime2.default)(json.hour, json.minute);
  }
  return date;
}